import { useI18n } from "@core/i18n/i18n";
import styled from "@emotion/styled";
import { ButtonsContainerHeader } from "@ui/pages/program-builder/header/components/buttons-container-header";
import { HeaderEditorButtonProps } from "@ui/pages/program-builder/header/program-builder-header";
import { row } from "@ui/style";
import { colors } from "@ui/style/colors";
import { isNil } from "@utils/assert";
import React from "react";

interface MobileProgramContentFooterProps {
	secondaryButton?: HeaderEditorButtonProps;
	primaryButton?: HeaderEditorButtonProps;
}

export const MobileProgramContentFooter: React.FC<MobileProgramContentFooterProps> = ({
	primaryButton,
	secondaryButton,
}) => {
	useI18n();

	if (isNil(primaryButton) && isNil(secondaryButton)) {
		return null;
	}

	return (
		<StickyBottom>
			<Footer>
				<ButtonsContainerHeader secondaryButton={secondaryButton} primaryButton={primaryButton} />
			</Footer>
		</StickyBottom>
	);
};

const StickyBottom = styled.div`
	position: sticky;
	bottom: 0;
	width: 100%;
	z-index: 99;
`;

const Footer = styled.div`
	${row(undefined, "spacearound", "center")};
	background: ${colors.white};
	border-top: 1px solid ${colors.primary10};
`;